import React, { useState, useCallback, useEffect } from 'react';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
import { Controller } from 'react-hook-form';
import { Autocomplete, CircularProgress, Box } from '@material-ui/core';
import { useLocation, useIntl } from 'umi';
import { useDispatch, useSelector } from 'dva';
import ChangeStoreStyled from './ChangeStoreStyled';
//防抖
function debounce(fn, ms = 2000) {
  let timer;
  return function (...args) {
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(() => {
      fn(...args);
      timer = null;
    }, ms);
  };
}
const ChangeStore = (props) => {
  const { control, setValue, errors } = props;
  //关于国际化
  const intl = useIntl();
  const { formatMessage } = intl;
  const dispatch = useDispatch();
  const [msValue, setMsValue] = useState();
  const [smsValue, setsMsValue] = useState();
  const [msInputValue, setMsInputValue] = useState();
  const [smsInputValue, setsMsInputValue] = useState();
  const [openManageStore, setOpenManageStore] = useState();
  const [opensManageStore, setOpensManageStore] = useState();
  const [msOptions, setMsOptions] = useState([]);
  const [smsOptions, setsMsOptions] = useState([]);
  const [managerStoreName, setManagerStoreName] = useState();
  const [serveManagerStoreName, setServeManagerStoreName] = useState();
  const [typeValue, setTypeValue] = useState('COUNTER');
  const loadingEffect = useSelector((state) => state.loading);
  const datas = useSelector((state) => state.adjustDetail.memberDetail);
  const storeListLoading = loadingEffect.effects['adjustList/getStoreList'];
  const storeServeListLoading =
    loadingEffect.effects['adjustList/getStoreList'];
  const ManageStoreLoading = openManageStore && storeListLoading === 0;
  const ManageServeStoreLoading =
    opensManageStore && storeServeListLoading === 0;
  const location = useLocation();
  const { query } = location;
  const { valueBefore, opt, type } = query;
  useEffect(() => {
    if (datas && !opt) {
      setValue('preRegisterStore', datas?.registerStoreName);
      setValue('preServeStore', datas?.mangeStoreName);
      setValue('type', 'COUNTER');
    }
  }, [datas, setValue, opt]);

  //获取门店列表
  const fetchManagerStoreList = useCallback(() => {
    dispatch({
      type: 'adjustList/getStoreList',
      payload: {
        values: {
          name: managerStoreName,
        },
      },
      callback: (res) => {
        setMsOptions(res.data.data);
      },
    });
  }, [dispatch, managerStoreName]);
  useEffect(() => {
    fetchManagerStoreList();
  }, [fetchManagerStoreList]);
  //获取门店列表
  const fetchServeManagerStoreList = useCallback(() => {
    dispatch({
      type: 'adjustList/getStoreList',
      payload: {
        values: {
          name: serveManagerStoreName,
        },
      },
      callback: (res) => {
        setsMsOptions(res.data.data);
      },
    });
  }, [dispatch, serveManagerStoreName]);
  useEffect(() => {
    fetchServeManagerStoreList();
  }, [fetchServeManagerStoreList]);
  useEffect(() => {
    if (opt === 'preview') {
      setValue('type', type === '服务门店变更' ? 'MANAGE_STORE' : 'COUNTER');
      setTypeValue(type === '服务门店变更' ? 'MANAGE_STORE' : 'COUNTER');
      setValue('preRegisterStore', valueBefore);
      setValue('registerStore', datas?.registerStoreName);
      setValue('preServeStore', valueBefore);
      setValue('serveStore', datas?.mangeStoreName);
    }
  }, [valueBefore, datas, opt, setValue]);
  console.log({ msInputValue });
  return (
    <ChangeStoreStyled>
      <Controller
        as={
          <FormControl component="fieldset">
            <RadioGroup
              className="checkbox-radio-disabled-color"
              row
              value={typeValue}
              onChange={(e) => setTypeValue(e.target.value)}
            >
              <FormControlLabel
                disabled={opt === 'preview'}
                value="COUNTER"
                control={<Radio />}
                label="注册门店"
              />
              <FormControlLabel
                disabled={opt === 'preview'}
                value="MANAGE_STORE"
                control={<Radio />}
                label="服务门店"
              />
            </RadioGroup>
          </FormControl>
        }
        name="type"
        control={control}
      />
      <div style={{ display: typeValue === 'COUNTER' ? 'block' : 'none' }}>
        <Box width={360} mt={4}>
          <Controller
            as={<TextField />}
            name="preRegisterStore"
            variant="standard"
            className="manageStore"
            label={formatMessage({
              id: 'adjustment.members.store.n02.lbl01',
            })}
            control={control}
            id="basic"
            disabled
            defaultValue={''}
          />
        </Box>
        <Box width={360} mt={4}>
          {opt === 'preview' ? (
            <Controller
              as={<TextField />}
              name="registerStore"
              variant="standard"
              className="manageStore"
              label={formatMessage({ id: 'adjustment.members.c01.lbl10' })}
              control={control}
              id="basic"
              disabled
              defaultValue={''}
            />
          ) : (
            <Controller
              name="registerStore"
              control={control}
              rules={{
                required: typeValue === 'COUNTER',
              }}
              error={Boolean(errors.registerStore)}
              render={() => (
                <Autocomplete
                  id="asynchronous-demo"
                  // sx={{ width: 300 }}
                  value={msValue}
                  inputValue={msInputValue}
                  onChange={(event, newValue) => {
                    setValue('registerStore', newValue);
                    setMsValue(newValue);
                  }}
                  onInputChange={(event, newValue) => {
                    setMsInputValue(newValue);
                    if (!newValue) {
                      setManagerStoreName();
                    }
                  }}
                  open={openManageStore}
                  onOpen={() => {
                    setOpenManageStore(true);
                  }}
                  onClose={() => {
                    setOpenManageStore(false);
                  }}
                  getOptionLabel={(option) => {
                    return option.name;
                  }}
                  options={msOptions}
                  loading={ManageStoreLoading}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={
                        <span>
                          <span className="red">*</span>{' '}
                          {formatMessage({
                            id: 'adjustment.members.c01.lbl10',
                          })}
                        </span>
                      }
                      placeholder={formatMessage({
                        id: 'adjustment.members.store.n02.lbl03',
                      })}
                      variant="standard"
                      rules={{
                        required: true,
                      }}
                      error={Boolean(errors.registerStore)}
                      helperText={
                        Boolean(errors.registerStore) &&
                        formatMessage({
                          id: 'adjustment.members.store.n02.lbl03',
                        })
                      }
                      onChange={debounce((e) => {
                        setManagerStoreName(e.target.value);
                      })}
                      onFocus={() => {
                        // fetchManagerStoreList();
                      }}
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <React.Fragment>
                            {ManageStoreLoading ? (
                              <CircularProgress color="inherit" size={16} />
                            ) : null}
                            {params.InputProps.endAdornment}
                          </React.Fragment>
                        ),
                      }}
                    />
                  )}
                />
              )}
            ></Controller>
          )}
        </Box>
      </div>
      <div style={{ display: typeValue === 'MANAGE_STORE' ? 'block' : 'none' }}>
        <Box width={360} mt={4}>
          <Controller
            as={<TextField />}
            name="preServeStore"
            variant="standard"
            className="manageStore"
            label="原服务门店"
            control={control}
            id="basic"
            disabled
            defaultValue={''}
          />
        </Box>
        <Box width={360} mt={4}>
          {opt === 'preview' ? (
            <Controller
              as={<TextField />}
              name="serveStore"
              variant="standard"
              className="manageStore"
              label="服务门店"
              control={control}
              id="basic"
              disabled
              defaultValue={''}
            />
          ) : (
            <Controller
              name="serveStore"
              control={control}
              rules={{
                required: typeValue === 'MANAGE_STORE',
              }}
              error={Boolean(errors.serveStore)}
              render={() => (
                <Autocomplete
                  id="asynchronous-demo"
                  // sx={{ width: 300 }}
                  value={smsValue}
                  inputValue={smsInputValue}
                  onChange={(event, newValue) => {
                    setValue('serveStore', newValue);
                    setsMsValue(newValue);
                  }}
                  onInputChange={(event, newValue) => {
                    setsMsInputValue(newValue);
                    if (!newValue) {
                      setServeManagerStoreName();
                    }
                  }}
                  open={opensManageStore}
                  onOpen={() => {
                    setOpensManageStore(true);
                  }}
                  onClose={() => {
                    setOpensManageStore(false);
                  }}
                  getOptionLabel={(option) => {
                    return option.name;
                  }}
                  options={smsOptions}
                  loading={ManageServeStoreLoading}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={
                        <span>
                          <span className="red">*</span> 服务门店
                        </span>
                      }
                      placeholder={formatMessage({
                        id: 'adjustment.members.store.n02.lbl03',
                      })}
                      variant="standard"
                      rules={{
                        required: true,
                      }}
                      error={Boolean(errors.serveStore)}
                      helperText={
                        Boolean(errors.serveStore) &&
                        formatMessage({
                          id: 'adjustment.members.store.n02.lbl03',
                        })
                      }
                      onChange={debounce((e) => {
                        setServeManagerStoreName(e.target.value);
                      })}
                      onFocus={() => {
                        // fetchServeManagerStoreList();
                      }}
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <React.Fragment>
                            {ManageServeStoreLoading ? (
                              <CircularProgress color="inherit" size={16} />
                            ) : null}
                            {params.InputProps.endAdornment}
                          </React.Fragment>
                        ),
                      }}
                    />
                  )}
                />
              )}
            ></Controller>
          )}
        </Box>
      </div>
    </ChangeStoreStyled>
  );
};
export default ChangeStore;
